import type { CountryIso } from "~/types"

const usaEligibleNationalities: CountryIso[] = [
  "AND",
  "AUS",
  "AUT",
  "BEL",
  "BRN",
  "CHL",
  "CZE",
  "DNK",
  "EST",
  "FIN",
  "FRA",
  "DEU",
  "GRC",
  "HUN",
  "ISL",
  "IRL",
  "ISR",
  "ITA",
  "JPN",
  "LVA",
  "LIE",
  "LTU",
  "LUX",
  "MLT",
  "MCO",
  "NLD",
  "NZL",
  "NOR",
  "POL",
  "PRT",
  "KOR",
  "SMR",
  "SGP",
  "SVK",
  "SVN",
  "ESP",
  "SWE",
  "CHE",
  "TWN",
  "GBR"
];

export default usaEligibleNationalities;